import LincolnAbrahamEmbed from "../images/LincolnAbrahamEmbed";
import Lincoln from "../Thumbs/Lincoln60.jpg";

const LincolnAbraham = {
    objectName: 'LincolnAbraham',
    firstName: 'Abraham',
    lastName: 'Lincoln',
    dates: '1809-1865',
    id: 'Lincoln1809-1865',
    image: LincolnAbrahamEmbed,
    thumbImg: Lincoln,
    quotes: [
    {
        tabHeading: `Lincoln's Second Inaugural Address`,
        metaDescription: `With malice toward none with charity for all with firmness in the right as God gives us to see the right.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Second Inaugural Address',
        id: 'LincolnSIA1865',
        date: 'March 4, 1865',
        headTitle: `Abraham Lincoln - Second Inaugural Address`,
        headDescription: `With malice toward none with charity for all with firmness in the right as God gives us to see the right`,
        content: [  
              {bold: `March 4, 1865`},  
              {normal: `Fellow countrymen: at this second appearing to take the oath of the presidential office there is less occasion for an extended address than 
            there was at the first. Then a statement somewhat in detail of a course to be pursued seemed fitting and proper. Now, at the expiration of four years 
            during which public declarations have been constantly called forth on every point and phase of the great contest which still absorbs the attention and 
            engrosses the energies of the nation little that is new could be presented. The progress of our arms, upon which all else chiefly depends is as well 
            known to the public as to myself and it is I trust reasonably satisfactory and encouraging to all. With high hope for the future no prediction in regard 
            to it is ventured.`},
              {normal: `On the occasion corresponding to this four years ago all thoughts were anxiously directed to an impending civil war. All dreaded it ~ all 
            sought to avert it. While the inaugural address was being delivered from this place devoted altogether to saving the Union without war insurgent 
            agents were in the city seeking to destroy it without war ~ seeking to dissolve the Union and divide effects by negotiation. Both parties deprecated 
            war but one of them would make war rather than let the nation survive, and the other would accept war rather than let it perish. And the war came.`},
              {normal: `One eighth of the whole population were colored slaves not distributed generally over the union but localized in the southern part of it. 
            These slaves constituted a peculiar and powerful interest. All knew that this interest was somehow the cause of the war. To strengthen perpetuate and 
            extend this interest was the object for which the insurgents would rend the Union even by war while the government claimed no right to do more than to 
            restrict the territorial enlargement of it. Neither party expected for the war the magnitude or the duration which it has already attained. Neither 
            anticipated that the cause of the conflict might cease with or even before the conflict itself should cease. Each looked for an easier triumph and a 
            result less fundamental and astounding. Both read the same Bible and pray to the same God and each invokes His aid against the other. It may seem strange 
            that any men should dare to ask a just God's assistance in wringing their bread from the sweat of other men's faces but let us judge not that we be not 
            judged. The prayers of both could not be answered ~ that of neither has been answered fully. The Almighty has His own purposes. "Woe unto the world because 
            of offenses for it must needs be that offenses come but woe to that man by whom the offense cometh." If we shall suppose that American slavery is one of 
            those offenses which in the providence of God must needs come but which having continued through His appointed time He now wills to remove and that He 
            gives to both North and South this terrible war as the woe due to those by whom the offense came shall we discern therein any departure from those divine 
            attributes which the believers in a living God always ascribe to Him. Fondly do we hope ~ fervently do we pray ~ that this mighty scourge of war may 
            speedily pass away. Yet, if God wills that it continue until all the wealth piled by the bondsman's two hundred and fifty years of unrequited toil shall 
            be sunk and until every drop of blood drawn with the lash shall be paid by another drawn with the sword as was said three thousand years ago so still it 
            must be said 'the judgments of the Lord are true and righteous altogether.'`},
              {bold: `With malice toward none with charity for all with firmness in the right as God gives us to see the right let us strive on to finish the work 
            we are in to bind up the nation's wounds, to care for him who shall have borne the battle and for his widow and his orphan ~ to do all which may achieve 
            and cherish a just and lasting peace among ourselves and with all nations`}
        ],
        considerations: [
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            },
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            },
            {
                name: '',
                title: '',
                date: '',
                content: [``]
            }
        ]
    },    {
        tabHeading: `Lincoln's Gettysburg Address`,
        metaDescription: `Four score and seven years ago our fathers brought forth on this continent, a new nation, conceived in Liberty`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Gettysburg Address',
        id: 'LincolnGA1863',
        date: 'November 19, 1863',
        headTitle: `Abraham Lincoln - Gettysburg Address`,
        headDescription: `Four score and seven years ago our fathers brought forth on this continent, a new nation, conceived in Liberty`,
        content: [
            {bold: `November 19, 1863`},
            {bold: `Four score and seven years ago our fathers brought forth on this continent, a new nation, conceived in Liberty, and dedicated to the proposition 
        that all men are created equal. `},
            {normal: `Now we are engaged in a great civil war, testing whether that nation, or any nation so conceived and so dedicated, can long endure. We are met 
        on a great battle-field of that war. We have come to dedicate a portion of that field, as a final resting place for those who here gave their lives that that 
        nation might live. It is altogether fitting and proper that we should do this. `},
            {bold: `But, in a larger sense, we can not dedicate -- we can not consecrate -- we can not hallow -- this ground. The brave men, living and dead, who 
        struggled here, have consecrated it, far above our poor power to add or detract.`}, 
            {normal: `The world will little note, nor long remember what we say here, but it can 
        never forget what they did here. It is for us the living, rather, to be dedicated here to the unfinished work which they who fought here have thus far so 
        nobly advanced. It is rather for us to be here dedicated to the great task remaining before us -- that from these honored dead we take increased devotion to 
        that cause for which they gave the last full measure of devotion -- that we here highly resolve that these dead shall not have died in vain -- that this nation, 
        under God, shall have a new birth of freedom -- and that government of the people, by the people, for the people, shall not perish from the earth.`}
        ],
        considerations: [
          {
              name: '',
              title: '',
              date: '',
              content: [``]
          },
          {
              name: '',
              title: '',
              date: '',
              content: [``]
          },
          {
              name: '',
              title: '',
              date: '',
              content: [``]
          }
      ]
    }
]};

export default LincolnAbraham;